import { getFlowKey } from '../routing/getFlowKey';
export const isFlow = flow => {
  const flowKey = getFlowKey();
  const flowKeysToCheck = Array.isArray(flow) ? flow : [flow];
  return flowKeysToCheck.includes(flowKey);
};